import RecoverPasswordFormComponent from "src/components/user/recover-password-form-component";
import SignInSideComponent from "src/components/user/sign-in-side-component";

function ForgetPasswordContainer() {
  return (
    <div className="flex flex-row justify-center items-center gap-[4%] mx-auto h-screen">
      <SignInSideComponent />
      <RecoverPasswordFormComponent />
    </div>
  );
}

export default ForgetPasswordContainer;
